import React, { useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { Pathname } from 'Routes';

// Landing route for /viewer/invite/:id. This component does no rendering of
// its own — it decides where the user should go:
//  - Not logged in: remember this path in `storedPath` and send to sign-in.
//    The sign-in flow reads `storedPath` and navigates back here after login.
//  - Logged in: stash the invite id for the dashboard popup and go to /dashboard.
export const ViewerInvite = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const token = localStorage.getItem('token');

    if (!token) {
      localStorage.setItem('storedPath', location.pathname);
      navigate(Pathname.authentication.newsignIn, { replace: true });
      return;
    }

    // Pass the invite id to the dashboard as a query param — the dashboard
    // popup reads it and clears it from the URL once shown.
    const target = id
      ? `${Pathname.dashboard}?viewerInvite=${encodeURIComponent(id)}`
      : Pathname.dashboard;
    navigate(target, { replace: true });
  }, []);

  return null;
};
